import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=60890160&scoped=true&"
import script from "./addDetail.vue?vue&type=script&lang=js&"
export * from "./addDetail.vue?vue&type=script&lang=js&"
import style0 from "./addDetail.vue?vue&type=style&index=0&id=60890160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60890160",
  null
  
)

export default component.exports